import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cubre el seguro SAINT® TMS?",
    answer:
      "SAINT® suele ser de pago directo y no suele estar cubierto por la mayoría de los planes de seguro. La TMS convencional está ampliamente cubierta. Verificamos los beneficios de cada paciente sin costo; la cobertura varía según el plan.",
  },
  {
    question: "¿Puedo verificar mis beneficios antes de decidir?",
    answer:
      "Sí. Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. Le proporcionamos un resumen antes de iniciar el tratamiento.",
  },
  {
    question: "¿SAINT® está en red con alguna aseguradora?",
    answer:
      "No afirmamos estar en red con ninguna aseguradora para SAINT®. Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. La cobertura varía según el plan.",
  },
];

export const esDoesInsuranceCover = makeEsArticle({
  slug: "does-insurance-cover-saint-tms",
  title: "¿Cubre el seguro SAINT® TMS? Cobertura y verificación",
  description:
    "¿Cubre el seguro SAINT® TMS? SAINT® suele ser de pago directo. Verificamos los beneficios de cada paciente sin costo, sea cual sea la aseguradora. La cobertura varía según el plan.",
  h1: "¿Cubre el seguro SAINT® TMS?",
  breadcrumbLabel: "¿Cubre el seguro SAINT® TMS?",
  shortAnswer:
    "SAINT® suele ser de pago directo y no suele estar cubierto por la mayoría de los planes de seguro. La TMS convencional está ampliamente cubierta para el trastorno depresivo mayor. Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. No afirmamos estar en red con ninguna aseguradora para SAINT®. La cobertura varía según el plan.",
  keyTakeaways: [
    "SAINT® suele ser de pago directo.",
    "La TMS convencional está ampliamente cubierta por los seguros.",
    "Verificamos los beneficios de cada paciente sin costo.",
    "No afirmamos estar en red con ninguna aseguradora para SAINT®.",
    "La cobertura varía según el plan.",
  ],
  sections: [
    {
      heading: "SAINT® y la cobertura del seguro",
      paragraphs: [
        "SAINT® suele ser de pago directo. Por su ritmo acelerado y su orientación por fMRI, SAINT® suele no estar cubierto por la mayoría de los planes de seguro. La TMS convencional, en cambio, está ampliamente cubierta para el trastorno depresivo mayor.",
      ],
    },
    {
      heading: "Verificación gratuita de beneficios",
      paragraphs: [
        "Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. Le proporcionamos un resumen de la cobertura y del costo antes de iniciar el tratamiento.",
        "No afirmamos estar en red con ninguna aseguradora para SAINT®. La cobertura varía según el plan. No estamos afiliados ni respaldados por ninguna aseguradora.",
      ],
    },
    {
      heading: "TMS convencional y seguro",
      paragraphs: [
        "Si SAINT® no está cubierto por su plan, la TMS convencional es una alternativa ampliamente cubierta por los seguros para el trastorno depresivo mayor. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793 para analizar sus opciones.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
